import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { BaseViewComponent, FormBase, Orientation } from '@sb/library/base';

@Component({
    selector: 'lib-data-card',
    templateUrl: './data-card.component.html',
    styleUrls: ['./data-card.component.scss']
})
export class DataCardComponent<T extends { [K in keyof T]: AbstractControl<any, any>; }> extends BaseViewComponent implements OnInit {

    @Input() hasCardContainer: boolean = true;
    @Input() form: FormGroup<T> | null = null;
    @Input() qaTag: string = "";

    @Output() discardButtonClicked = new EventEmitter();
    @Output() saveButtonClicked = new EventEmitter();

    readonly orientation: Orientation = this.isMobile ? Orientation.Vertical : Orientation.Horizontal;


    DiscardClicked(): void {
        this.form?.Reset();
        this.discardButtonClicked.emit(true);
    }

    SaveClicked(): void {
        this.saveButtonClicked.emit(true);
    }


}